import React from "react";

const STYLES = {
    private: { bg: "#FEF2F2", text: "#DC2626", border: "#FECACA", label: "Private" },
    household: { bg: "#ECFDF5", text: "#059669", border: "#A7F3D0", label: "Household" },
    estate_shared: { bg: "#EFF6FF", text: "#2563EB", border: "#BFDBFE", label: "Estate" },
    agency_shared: { bg: "#FFFBEB", text: "#D97706", border: "#FDE68A", label: "Agency" },
    admin_only: { bg: "#F5F3FF", text: "#7C3AED", border: "#DDD6FE", label: "Admin" },
};

export default function PrivacyBadge({ visibility }) {
    const s = STYLES[visibility] || STYLES.private;
    return (
        <span
            data-testid={`privacy-badge-${visibility}`}
            className="inline-flex items-center px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide border rounded"
            style={{ backgroundColor: s.bg, color: s.text, borderColor: s.border }}
        >
            {s.label}
        </span>
    );
}
